import { useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { erpApi } from "@/shared/axios";
import { toApiError } from "@/shared/utils/general";
import { queryClient } from '@/shared/query-client/query-client';
// import { Aprobacion, ResponderAprobacionRequest } from './aprobacion.types';
import {Aprobacion, ResponderAprobacionRequest} from '@/erp/controlcambios/cambio-service'
import { urlBackend } from "@/shared/constants";
const { get, put } = erpApi();


// export const useFetchMisAprobaciones = (usuarioId: number) => {
//   return useQuery({
//     queryKey: ['mis-aprobaciones', usuarioId],
//     queryFn: async () => (await get<Aprobacion[]>(`${urlBackend}api/v1/cambios/aprobaciones/mis-aprobaciones/${usuarioId}`, true)) as unknown as Aprobacion[],
//     enabled: !!usuarioId,
//   });
// };
export const useFetchMisAprobaciones = (
  usuarioId: number,
  params: { tipo?: string; page?: number; size?: number } = {},
) =>
  useQuery({
    queryKey: ['mis-aprobaciones', usuarioId, params.tipo, params.page, params.size],
    queryFn: () =>
      get<{ data: Aprobacion[]; totalElements: number; page: number; size: number; totalPages: number }>(
        `${urlBackend}api/v1/cambios/aprobaciones/mis-aprobaciones/${usuarioId}` +
        `?tipo=${params.tipo ?? ''}&page=${params.page ?? 0}&size=${params.size ?? 10}`,
        true,
      ),
    enabled: !!usuarioId,
  });

export const useFetchResponderAprobacion = () => {
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: ResponderAprobacionRequest }) =>
      put<Aprobacion>(`${urlBackend}api/v1/cambios/aprobaciones/${id}/responder`, data, true),
   onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['mis-aprobaciones'] });
      queryClient.invalidateQueries({ queryKey: ['cambios'] });       
      queryClient.invalidateQueries({ queryKey: ['mis-cambios'] });  
      queryClient.invalidateQueries({ queryKey: ['aprobaciones-cambio'] });   // 👈 nuevo (tabla de aprobaciones del ver)
      queryClient.invalidateQueries({ queryKey: ['cambio'] });
      const mensaje =
        variables.data.estadoAprobacion === 'APROBADO'
          ? 'Aprobación aprobada correctamente'
          : 'Aprobación rechazada correctamente';
      toast.success(mensaje);
    },
    onError: (error) => {
      const data = toApiError(error);
      toast.error(data.message);
    },
  });
};



export const useFetchAprobacionesPorCambio = (cambioId: string) =>
  useQuery({
    queryKey: ["aprobaciones-cambio", cambioId],
    queryFn: async () =>
      (await get<any>(`${urlBackend}api/v1/cambios/aprobaciones/cambio/${cambioId}`, true)) as unknown as any[],
    enabled: !!cambioId,
  });